import React, { useState, useEffect, useRef } from "react";
import parse from "html-react-parser";
import CountUp from "react-countup";
import DataFetcher from "../DataFetcher/DataFetcher";

const CounterItem = ({ value, name, delay }) => {
  const ref = useRef();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Stop observing once visible
        }
      },
      {
        threshold: 0.5,
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div
      ref={ref}
      className="col-md-2 counter col-sm-4 text-center"
      data-aos="fade-up"
      data-aos-delay={`${delay}00`}
      data-aos-duration={700}
    >
      <h2 className="count white-color font-700 text-center">
        {isVisible ? <CountUp start={0} end={value} duration={2} /> : 0}
      </h2>
      <h3 className="text-left">{name}</h3>
    </div>
  );
};


const Numbers = ({
  title,
  tagline,
  paragraph1,
  paragraph2,
  paragraph3,
  paragraph4,
  apiUrl,
  children,
}) => {
  // const API_URL = `${process.env.REACT_APP_API_BASE_URL}?op=numbers`;

  return (
    <section
      className="parallax-bg-17 fixed-bg fact-section text-center"
      data-stellar-background-ratio="0.2"
    >
      <div className="col-md-2">
        <h4
          className="text-uppercase"
          data-aos="fade-right"
          data-aos-delay={100}
          data-aos-duration={700}
        >
          - -
        </h4>
      </div>
      <div className="overlay-bg text-center"></div>
      <div className="container">
        <div className="row white-color">
          <div className="col-md-2">
            <h1
              className="text-uppercase font-700"
              data-aos="fade-right"
              data-aos-delay={100}
              data-aos-duration={700}
            >
              {title}
            </h1>
            <h4
              className="text-uppercase"
              data-aos="fade-right"
              data-aos-delay={100}
              data-aos-duration={700}
            >
              - {tagline} -
            </h4>
          </div>
          <div className="col-md-8">
            {paragraph1}
            <h2
              className="text-uppercase"
              data-aos="fade-right"
              data-aos-delay={100}
              data-aos-duration={700}
            >
              <br />
              <br />
              {paragraph2}
            </h2>
            <h3
              className="text-uppercase"
              data-aos="fade-right"
              data-aos-delay={100}
              data-aos-duration={700}
            >
              - {paragraph3} -
            </h3>
            <div
              className="mt-15"
              data-aos="fade-up"
              data-aos-delay={200}
              data-aos-duration={700}
            >
              {children ? parse(children) : ""}
            </div>
          </div>
        </div>

        <div className="row mt-30">
          <div className="col-md-8"></div>
          <div className="col-md-12">
            <div className="row">
              <DataFetcher url={apiUrl}>
                {(dataCounters) =>
                  dataCounters.map((counter, i) => (
                    <CounterItem
                      key={i}
                      value={counter.value}
                      name={counter.name}
                      delay={i}
                    />
                  ))
                }
              </DataFetcher>
            </div>
          </div>
        </div>

        <br />
        <br />
        <h6
          className="text-uppercase white"
          data-aos="fade-right"
          data-aos-delay={100}
          data-aos-duration={700}
        >
          {paragraph4}
        </h6>
      </div>
    </section>
  );
};

export default Numbers;
